import _ from 'lodash';

import { AssistedApplicationErrorIds } from '@breathelife/errors';
import { NodeIds } from '@breathelife/insurance-form-builder';
import { InstanceScope, NodeId, QuestionnaireEngine, VersionedAnswers, YesNoValues } from '@zinnia/form-engine-sdk';

import { getErrorIdsFromError } from '../../Localization/errorIdsToTranslationMap';

type ShouldRefreshAllAnswersParams = {
  answers?: VersionedAnswers;
  currentProposedInsuredIndex: number;
  questionnaireEngine: QuestionnaireEngine;
  nodeIdsSkippingDebounce?: NodeId[];
  updatedNodeIds?: NodeId[];
};

// Checks whether the conditions are met to refresh all the answers
export function shouldRefreshAllAnswers({
  currentProposedInsuredIndex,
  questionnaireEngine,
  nodeIdsSkippingDebounce,
  updatedNodeIds,
}: ShouldRefreshAllAnswersParams): boolean {
  if (!_.isArray(nodeIdsSkippingDebounce) || nodeIdsSkippingDebounce.length === 0) return false;
  const updatedNodesSkippingDebounce = _.intersection(nodeIdsSkippingDebounce, updatedNodeIds);
  if (updatedNodesSkippingDebounce.length === 0) return false;
  const scope: InstanceScope = {
    [NodeIds.insuredPeople]: currentProposedInsuredIndex,
  };
  return updatedNodesSkippingDebounce.some((nodeId) => {
    return questionnaireEngine.getAnswer(nodeId, scope) === YesNoValues.yes;
  });
}

// The backend throws this error if payload's application.answerUpdatedAt
// does not match db's application.answerUpdatedAt
export function isAnswerTimestampMismatchError(error: unknown): boolean {
  const errorIds = getErrorIdsFromError(error);

  return (
    Array.isArray(errorIds) &&
    errorIds.includes(AssistedApplicationErrorIds.AnswersSafeguardBadRequestAnswersUpdatedAtMismatch)
  );
}
